import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetMyInterestsQuery } from '../../../../../../redux/services/fij_applications.jsx';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import FijMyInterestsTable from './FijMyInterestsTable.jsx';

const FijMyInterestsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: myInterests, isLoading, refetch } = useGetMyInterestsQuery();

  const pageTitle = t('Môj záujem');

  useEffect(() => {
    document.title = pageTitle + ' - FRI.jobs';
  }, [pageTitle]); // Runs on mount

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <FijMyInterestsTable
            myInterests={myInterests}
            refetchData={refetch}
            onDetailClick={(record) =>
              navigate(`${routes.cmsFijJobDetail}/${record}`)
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default FijMyInterestsPage;
